import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCommunity = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 12,
	viewBox: "0 0 15 12",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", { id: "a" }),
		/* @__PURE__ */ _jsx("g", {
			id: "b",
			children: /* @__PURE__ */ _jsx("g", {
				id: "c",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M5.09,7.12H.41c-.23,0-.41-.2-.41-.44,0-1.21,.92-2.19,2.06-2.19h1.45c.3,0,.58,.05,.83,.19-.01,.12-.04,.25-.04,.37,0,.79,.3,1.5,.78,2.06ZM1.12,1.88C1.12,.84,1.96,0,3,0s1.88,.84,1.88,1.88-.84,1.88-1.88,1.88-1.88-.84-1.88-1.88ZM12,11.37c0,.35-.3,.63-.67,.63H3.67c-.37,0-.67-.28-.67-.63,0-1.72,1.49-3.12,3.33-3.12h2.34c1.84,0,3.33,1.4,3.33,3.12Zm-1.19-.5c-.25-.86-1.11-1.5-2.14-1.5h-2.36c-1.03,0-1.89,.64-2.14,1.5h6.63ZM5.08,5.06c0-1.35,1.07-2.44,2.42-2.44s2.42,1.09,2.42,2.44-1.07,2.44-2.42,2.44-2.44-1.09-2.42-2.44Zm1.1,0c0,.72,.59,1.31,1.31,1.31s1.31-.59,1.31-1.31-.59-1.31-1.31-1.31-1.31,.59-1.31,1.31Zm8.81,1.62c0,.24-.19,.44-.41,.44h-4.68c.48-.56,.78-1.27,.78-2.06,0-.13-.02-.25-.04-.37,.26-.12,.54-.19,.84-.19h1.45c1.14,0,2.06,.98,2.06,2.19ZM10.12,1.88c0-1.04,.84-1.88,1.88-1.88s1.88,.84,1.88,1.88-.84,1.88-1.88,1.88-1.88-.84-1.88-1.88Z",
					fill: "#231f20"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgCommunity);
export default ForwardRef;
